<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="92" height="39" viewBox="0 0 92 39">
        <g id="Groupe_10" data-name="Groupe 10" transform="translate(-426 -780)">
            <rect id="Rectangle_309" data-name="Rectangle 309" width="92" height="39" rx="6" transform="translate(426 780)" fill="#a8a8a8" />
            <path
                id="Icon_awesome-play"
                data-name="Icon awesome-play"
                d="M19.053,9.639,3.25.3A2.143,2.143,0,0,0,0,2.151v18.68a2.153,2.153,0,0,0,3.25,1.854l15.8-9.338a2.153,2.153,0,0,0,0-3.708Z"
                transform="translate(461.944 788.005)"
                fill="#f4f4f4"
            />
        </g>
    </svg>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// IconeVideo.vue?cef50d60